var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgotPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 428.14 443.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}.cls-2{fill:#ebebeb;}.cls-3{fill:#e0e0e0;}.cls-4{fill:#fff;}.cls-5{fill:#263238;}.cls-6{fill:#0092bc;}.cls-7{opacity:0.3;}.cls-8{fill:#fafafa;}.cls-9{opacity:0.5;}.cls-10{fill:#455a64;}.cls-11{fill:#ffbe9d;}.cls-12{fill:#eb996e;}.cls-13{opacity:0.6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M431.67,117.79a13.29,13.29,0,0,0,7.92-12.29c0-7.34-5.53-13.31-12.41-13.34s-12.48,5.89-12.51,13.23a13.27,13.27,0,0,0,7.94,12.4c-19.17,2.89-18.3,23.73-18.3,23.73l45.33.21S450.68,120.66,431.67,117.79Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.82,39.92,134.19,29.44,104.85,39.78c-3.74,1.74-7,2.78-7,6.22V63.11a63.92,63.92,0,0,0,9.67,34,59.88,59.88,0,0,0,27,23.48c12-3.84,20.94-14.06,26.42-22.81a64,64,0,0,0,9.66-34V48.39C170.56,43.49,167.92,41.1,163.82,39.92Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144,67.54a8.2,8.2,0,1,0-10.44,7.85V87.66h4.48V75.39A8.17,8.17,0,0,0,144,67.54Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M415.74,198.49l5.05,2.74-2.27,3.8-5.1-3,.1,5.61h-4.36l0-5.66L404.11,205l-2.23-3.8,5.05-2.74-5.05-2.78,2.23-3.8L409.2,195l0-5.66h4.36l-.1,5.66,5.1-3.06,2.27,3.8Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M436.78,198.49l5.05,2.74-2.27,3.8-5.1-3,.1,5.61H430.2l.05-5.66-5.1,3.06-2.23-3.8,5.05-2.74-5.05-2.78,2.23-3.8,5.1,3.06-.05-5.66h4.36l-.1,5.66,5.1-3.06,2.27,3.8Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M457.82,198.49l5.06,2.74-2.27,3.8-5.1-3,.09,5.61h-4.36l.05-5.66-5.1,3.06-2.23-3.8,5.06-2.74L444,195.71l2.23-3.8,5.1,3.06-.05-5.66h4.36l-.09,5.66,5.1-3.06,2.27,3.8Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "207.8 408.41 207.8 439.47 253.23 439.47 303.33 439.47 303.33 408.41 207.8 408.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "203.8 399.73 203.8 408.41 306.67 408.41 306.67 399.73 253.23 399.73 203.8 399.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "255.23 439.47 303.33 439.47 303.33 408.41 306.67 408.41 306.67 399.73 253.23 399.73 253.23 407.61 255.23 439.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 221.16,
    y: 413.42,
    width: 19.37,
    height: 4.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.67,
    y: 423.94,
    width: 24.88,
    height: 9.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "222.5 368.71 222.5 399.77 267.93 399.77 318.03 399.77 318.03 368.71 222.5 368.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "218.49 360.02 218.49 368.71 321.37 368.71 321.37 360.02 267.93 360.02 218.49 360.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "269.93 399.77 318.03 399.77 318.03 368.71 321.37 368.71 321.37 360.02 267.93 360.02 267.93 367.9 269.93 399.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 235.86,
    y: 373.72,
    width: 19.37,
    height: 4.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 233.37,
    y: 384.24,
    width: 24.88,
    height: 9.87
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M464.07,469.16c0,.14-95.85.26-214.06.26s-214.08-.12-214.08-.26,95.83-.26,214.08-.26S464.07,469,464.07,469.16Z",
    transform: "translate(-35.93 -29.44)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Screens"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 154.58,
    y: 18.84,
    width: 191.76,
    height: 177.47,
    rx: 6.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.71,225.76l.47,0a6.65,6.65,0,0,0,1.37-.26,6.53,6.53,0,0,0,4-3.47,7.94,7.94,0,0,0,.62-3.94c0-1.49,0-3.13,0-4.9,0-3.54,0-7.63,0-12.23,0-18.4-.05-45-.09-77.92,0-16.45,0-34.46,0-53.81q0-7.24,0-14.73a6.33,6.33,0,0,0-4.1-5.54,9.42,9.42,0,0,0-3.69-.4H338.6l-141.51,0A6.33,6.33,0,0,0,193,50.09,6.26,6.26,0,0,0,190.84,54a19.37,19.37,0,0,0-.07,2.3v61.57c0,23.67,0,46.5,0,68.25q0,16.32,0,31.79c0,.64,0,1.3,0,1.91a6.5,6.5,0,0,0,.43,1.79,6.33,6.33,0,0,0,2.27,2.84,6.23,6.23,0,0,0,3.43,1.12h18.51l53.81,0,77.92.09,21.18,0,5.51,0,1.88,0-1.88,0-5.51,0-21.18.05-77.92.08-53.81,0H196.89a6.77,6.77,0,0,1-6.11-4.24,7.1,7.1,0,0,1-.47-1.92c-.05-.68,0-1.3,0-1.95q0-15.47,0-31.79c0-21.75,0-44.58,0-68.25q0-17.76,0-36.11V56.25a17.33,17.33,0,0,1,.08-2.37,6.67,6.67,0,0,1,2.28-4.18A6.88,6.88,0,0,1,197.09,48l141.51,0h35.63a9.76,9.76,0,0,1,3.85.44,6.78,6.78,0,0,1,4.39,5.93q0,7.5,0,14.76c0,19.35,0,37.36,0,53.81,0,32.9-.06,59.52-.08,77.92,0,4.6,0,8.69,0,12.23,0,1.77,0,3.41,0,4.9a8,8,0,0,1-.66,4,6.54,6.54,0,0,1-5.49,3.71Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205,60.59a3.32,3.32,0,1,1-3.31-3.32A3.31,3.31,0,0,1,205,60.59Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 175.42,
    cy: 31.14,
    r: 3.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 185.1,
    cy: 31.14,
    r: 3.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382.27,70c0,.15-42.93.26-95.88.26s-95.88-.11-95.88-.26,42.92-.26,95.88-.26S382.27,69.85,382.27,70Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.48,136.85s.07-.11.23-.31l.13-.17.13-.23a4.46,4.46,0,0,0,.29-.58c0-.11.1-.23.14-.36l.12-.42a3.56,3.56,0,0,0,.1-.47c0-.17.06-.34.07-.52a9.88,9.88,0,0,0-.12-2.49,22,22,0,0,0-2.28-6.43,50.66,50.66,0,0,0-4.91-7.63,78.08,78.08,0,0,0-7.31-8.22,89.82,89.82,0,0,0-9.61-8.19c-1.79-1.32-3.68-2.6-5.67-3.8a54.63,54.63,0,0,0-6.31-3.31,29.73,29.73,0,0,0-7-2.2,12.34,12.34,0,0,0-3.74-.09,6.81,6.81,0,0,0-1.81.52,5.31,5.31,0,0,0-1.51,1.11,5,5,0,0,0-.94,1.63,6.9,6.9,0,0,0-.31,1.86,12.55,12.55,0,0,0,.51,3.71,29.66,29.66,0,0,0,3,6.72,53.84,53.84,0,0,0,4,5.89c1.42,1.84,2.91,3.58,4.42,5.21a89,89,0,0,0,9.24,8.61,77.5,77.5,0,0,0,9,6.33,50.69,50.69,0,0,0,8.14,4,22.53,22.53,0,0,0,6.65,1.54,10.58,10.58,0,0,0,2.48-.17c.18,0,.34-.09.5-.13a4.15,4.15,0,0,0,.46-.15l.4-.17.35-.18a3.61,3.61,0,0,0,.54-.36l.21-.15.16-.15c.18-.18.28-.26.28-.26l-.27.27-.16.15-.2.16a3.28,3.28,0,0,1-.55.36L312,138l-.41.17a3,3,0,0,1-.45.15,4.25,4.25,0,0,1-.51.14,9.66,9.66,0,0,1-2.5.18,22.18,22.18,0,0,1-6.67-1.51,50.79,50.79,0,0,1-8.17-4,77.64,77.64,0,0,1-9-6.33,88,88,0,0,1-9.26-8.61c-1.51-1.63-3-3.37-4.43-5.21a55.71,55.71,0,0,1-4-5.91,29.72,29.72,0,0,1-3-6.75,12.47,12.47,0,0,1-.52-3.76,7.13,7.13,0,0,1,.32-1.89,5.39,5.39,0,0,1,1-1.69,5.14,5.14,0,0,1,1.56-1.14,7.13,7.13,0,0,1,1.85-.54,12.66,12.66,0,0,1,3.79.09,29.86,29.86,0,0,1,7.05,2.22,54,54,0,0,1,6.32,3.32c2,1.2,3.89,2.48,5.68,3.81a87.87,87.87,0,0,1,9.61,8.22,77.35,77.35,0,0,1,7.32,8.24,50.53,50.53,0,0,1,4.89,7.65,22.13,22.13,0,0,1,2.27,6.46,9.94,9.94,0,0,1,.1,2.51,3.89,3.89,0,0,1-.08.51,2.17,2.17,0,0,1-.1.47l-.12.43a3,3,0,0,1-.15.36,2.6,2.6,0,0,1-.3.58,1.26,1.26,0,0,1-.13.23l-.13.17Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.55,114.93l0-.38,0-.21c0-.08,0-.16-.05-.26a3.15,3.15,0,0,0-.17-.63c0-.11-.08-.24-.13-.36l-.2-.4a2.18,2.18,0,0,0-.24-.41,3.61,3.61,0,0,0-.29-.43,9.32,9.32,0,0,0-1.74-1.78,22.21,22.21,0,0,0-6-3.28,50.31,50.31,0,0,0-8.74-2.43A77.52,77.52,0,0,0,294,103.1a90.23,90.23,0,0,0-12.63.27c-2.21.21-4.47.52-6.76.95a53.29,53.29,0,0,0-6.91,1.73,29,29,0,0,0-6.7,3,12.21,12.21,0,0,0-2.85,2.42,6.76,6.76,0,0,0-1,1.59,5.07,5.07,0,0,0-.4,1.84,5.32,5.32,0,0,0,.39,1.84,7.1,7.1,0,0,0,1,1.59,12.54,12.54,0,0,0,2.86,2.43,29.62,29.62,0,0,0,6.7,3,56.75,56.75,0,0,0,6.91,1.73c2.29.43,4.55.73,6.76.94a88.85,88.85,0,0,0,12.63.28A80.59,80.59,0,0,0,305,125.51a50.31,50.31,0,0,0,8.74-2.43,22.77,22.77,0,0,0,6-3.28,9.62,9.62,0,0,0,1.74-1.78,3.7,3.7,0,0,0,.29-.44,2.18,2.18,0,0,0,.24-.41l.2-.39c.05-.13.09-.25.13-.37a3,3,0,0,0,.17-.63c0-.09,0-.17.05-.25l0-.21,0-.39s0,.13,0,.39l0,.21c0,.08,0,.16,0,.26a3.06,3.06,0,0,1-.16.63c0,.12-.08.24-.13.37l-.19.4a3.7,3.7,0,0,1-.24.42,4.65,4.65,0,0,1-.29.43,9.38,9.38,0,0,1-1.74,1.8,22.13,22.13,0,0,1-6,3.31,50.08,50.08,0,0,1-8.75,2.46,79,79,0,0,1-11,1.28,88.86,88.86,0,0,1-12.64-.26c-2.22-.21-4.49-.51-6.78-.94a57.52,57.52,0,0,1-6.93-1.73,29.43,29.43,0,0,1-6.73-3,12.49,12.49,0,0,1-2.89-2.45,7.08,7.08,0,0,1-1-1.63,4.61,4.61,0,0,1,0-3.8,7.44,7.44,0,0,1,1-1.63A12.74,12.74,0,0,1,261,109a29.7,29.7,0,0,1,6.74-3,53.84,53.84,0,0,1,6.92-1.73c2.3-.43,4.56-.73,6.78-.94A88.92,88.92,0,0,1,294,103a77.46,77.46,0,0,1,11,1.29,49.74,49.74,0,0,1,8.75,2.45,22.13,22.13,0,0,1,6,3.31,9.67,9.67,0,0,1,1.74,1.8,3.7,3.7,0,0,1,.29.44,3,3,0,0,1,.24.42l.19.39c.05.13.09.26.13.37a3.14,3.14,0,0,1,.16.64c0,.09,0,.18,0,.25l0,.22C322.55,114.8,322.55,114.93,322.55,114.93Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M310.53,87.66l-.33-.21-.18-.12a1.67,1.67,0,0,0-.23-.11,3.1,3.1,0,0,0-.6-.25c-.12,0-.24-.09-.37-.12l-.43-.09a3.54,3.54,0,0,0-.47-.07,4.41,4.41,0,0,0-.52,0,10,10,0,0,0-2.48.28,22.59,22.59,0,0,0-6.26,2.73,49.59,49.59,0,0,0-7.27,5.42,78,78,0,0,0-7.7,7.86,88.78,88.78,0,0,0-7.51,10.15C275,115,273.84,117,272.78,119a54,54,0,0,0-2.87,6.52,30.09,30.09,0,0,0-1.71,7.15,12.36,12.36,0,0,0,.17,3.74,7.11,7.11,0,0,0,.65,1.77,5.05,5.05,0,0,0,1.21,1.44,5.18,5.18,0,0,0,1.69.81,6.91,6.91,0,0,0,1.87.19,12.45,12.45,0,0,0,3.67-.77,29.68,29.68,0,0,0,6.5-3.44,54.59,54.59,0,0,0,5.6-4.4c1.74-1.55,3.37-3.15,4.89-4.77a89.82,89.82,0,0,0,7.95-9.81,78,78,0,0,0,5.7-9.41,50.18,50.18,0,0,0,3.44-8.39,22.41,22.41,0,0,0,1.07-6.75,9.3,9.3,0,0,0-.34-2.46c0-.18-.11-.34-.16-.5s-.11-.3-.18-.44l-.19-.39c-.07-.12-.15-.23-.21-.33a2.94,2.94,0,0,0-.4-.52l-.16-.2-.16-.14-.28-.26.29.25.16.14a1.62,1.62,0,0,1,.17.19,3.22,3.22,0,0,1,.4.52c.07.11.15.21.22.33l.19.4a2.53,2.53,0,0,1,.19.44c.05.16.12.32.16.5a9.27,9.27,0,0,1,.36,2.47,22.12,22.12,0,0,1-1.05,6.77,51.05,51.05,0,0,1-3.42,8.42,78.15,78.15,0,0,1-5.7,9.43,87.89,87.89,0,0,1-7.95,9.83c-1.52,1.63-3.15,3.24-4.9,4.79a55.09,55.09,0,0,1-5.61,4.41,29.51,29.51,0,0,1-6.53,3.46,12.66,12.66,0,0,1-3.71.78,7.32,7.32,0,0,1-1.92-.19,5.42,5.42,0,0,1-1.74-.85,5.22,5.22,0,0,1-1.25-1.48,7.3,7.3,0,0,1-.67-1.81,12.64,12.64,0,0,1-.16-3.78,29.61,29.61,0,0,1,1.72-7.19,54.17,54.17,0,0,1,2.87-6.53c1.07-2.08,2.22-4.06,3.41-5.94a90.09,90.09,0,0,1,7.54-10.15A77,77,0,0,1,291.32,95a50.47,50.47,0,0,1,7.3-5.42,22.42,22.42,0,0,1,6.29-2.7,9.63,9.63,0,0,1,2.49-.28c.18,0,.35,0,.52,0a3.46,3.46,0,0,1,.48.07l.43.09.37.13a3.08,3.08,0,0,1,.6.26,1.67,1.67,0,0,1,.23.11l.18.13Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256.35,128.52a1.22,1.22,0,1,1-1.73,0A1.22,1.22,0,0,1,256.35,128.52Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M325.34,90.63a1.23,1.23,0,1,1-1.23-1.22A1.22,1.22,0,0,1,325.34,90.63Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M264.07,132.54a.31.31,0,1,1-.31-.31A.31.31,0,0,1,264.07,132.54Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.7,98.28a.31.31,0,1,1-.31-.31A.31.31,0,0,1,270.7,98.28Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.19,114.93a.31.31,0,0,1-.31.31.31.31,0,1,1,0-.62A.31.31,0,0,1,319.19,114.93Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323.51,100.45a.31.31,0,0,1-.62,0,.31.31,0,0,1,.62,0Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302.57,121.76h-3.84V100.85a8.93,8.93,0,1,0-17.86,0v20.91H277V100.85a12.77,12.77,0,1,1,25.54,0Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.57,121.76h-3.84V100.85a8.93,8.93,0,1,0-17.86,0v20.91H277V100.85a12.77,12.77,0,1,1,25.54,0Z",
    transform: "translate(-35.93 -29.44)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 236.66,
    y: 83.02,
    width: 34.42,
    height: 22.08,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.68,120.63a2.88,2.88,0,1,0-3.66,2.75v4.3h1.56v-4.3A2.86,2.86,0,0,0,292.68,120.63Z",
    transform: "translate(-35.93 -29.44)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M274.43,132.45c-.08,0-.15-3.68-.15-8.22s.07-8.23.15-8.23.14,3.68.14,8.23S274.5,132.45,274.43,132.45Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M287.55,124.31s-.14,0-.34-.19a3.48,3.48,0,0,1-.74-.75,4,4,0,0,1,1.43-6.05,3.42,3.42,0,0,1,1-.35,1.06,1.06,0,0,1,.39,0,10.1,10.1,0,0,0-1.29.54,4,4,0,0,0-1.37,5.76A8.63,8.63,0,0,0,287.55,124.31Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 189.68,
    y: 124.02,
    width: 124.61,
    height: 19.78,
    rx: 9.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 190.59,
    y: 151.15,
    width: 124.61,
    height: 19.78,
    rx: 9.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M245.3,163.2v-2.86h1.19v2.82c0,1,.42,1.37,1.14,1.37s1.14-.4,1.14-1.37v-2.82h1.17v2.86a2.32,2.32,0,1,1-4.64,0Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.65,165.09l.37-.82a2.7,2.7,0,0,0,1.37.38c.53,0,.72-.14.72-.36,0-.64-2.37,0-2.37-1.55,0-.75.67-1.28,1.82-1.28a3.21,3.21,0,0,1,1.51.35l-.38.81a2.21,2.21,0,0,0-1.13-.29c-.51,0-.73.16-.73.36,0,.67,2.37,0,2.37,1.57,0,.73-.67,1.25-1.85,1.25A3.35,3.35,0,0,1,250.65,165.09Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M258.74,163.81h-3a1.05,1.05,0,0,0,1.13.79,1.35,1.35,0,0,0,1-.38l.61.66a2.08,2.08,0,0,1-1.62.63,2,2,0,0,1-2.25-2,2,2,0,0,1,2.1-2,2,2,0,0,1,2.05,2C258.76,163.59,258.74,163.71,258.74,163.81Zm-3-.67h1.93a1,1,0,0,0-1.93,0Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M262,161.46v1.06l-.26,0a1,1,0,0,0-1,1.1v1.85h-1.14v-3.93h1.09V162A1.57,1.57,0,0,1,262,161.46Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M266.66,163.2v2.25h-1.14v-2.07c0-.64-.29-.93-.8-.93s-.94.34-.94,1.06v1.94h-1.14v-3.93h1.09V162a1.74,1.74,0,0,1,1.3-.52A1.54,1.54,0,0,1,266.66,163.2Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M271.17,163.21v2.24H270.1V165a1.29,1.29,0,0,1-1.2.55c-.92,0-1.47-.51-1.47-1.19s.49-1.18,1.69-1.18H270c0-.48-.29-.77-.91-.77a1.89,1.89,0,0,0-1.13.37l-.41-.8a3,3,0,0,1,1.7-.48C270.47,161.46,271.17,162,271.17,163.21Zm-1.14,1v-.4h-.78c-.54,0-.7.2-.7.46s.24.48.64.48A.84.84,0,0,0,270,164.21Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.84,163.2v2.25H277.7v-2.07c0-.64-.28-.93-.74-.93s-.87.33-.87,1v2H275v-2.07c0-.64-.27-.93-.75-.93s-.86.33-.86,1v2H272.2v-3.93h1.09V162a1.58,1.58,0,0,1,1.23-.52,1.49,1.49,0,0,1,1.3.65,1.74,1.74,0,0,1,1.42-.65A1.52,1.52,0,0,1,278.84,163.2Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.74,163.81h-3a1,1,0,0,0,1.12.79,1.36,1.36,0,0,0,1-.38l.6.66a2.06,2.06,0,0,1-1.62.63,2,2,0,0,1-2.24-2,2,2,0,0,1,2.1-2,2,2,0,0,1,2,2C283.76,163.59,283.75,163.71,283.74,163.81Zm-3-.67h1.94a.94.94,0,0,0-1-.81A.92.92,0,0,0,280.75,163.14Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.28,163.45c0,1.31-.6,2.06-1.5,2.06a1,1,0,0,1-1-.64,1.39,1.39,0,0,1-1.25.64,1.86,1.86,0,0,1,0-3.7,1.38,1.38,0,0,1,1.12.49v-.43h1v2.36c0,.35.15.47.35.47s.54-.39.54-1.23a2.49,2.49,0,0,0-2.72-2.51,2.65,2.65,0,1,0,0,5.3,3.42,3.42,0,0,0,1.44-.32l.23.67a3.87,3.87,0,0,1-1.67.35,3.35,3.35,0,1,1,0-6.69A3.2,3.2,0,0,1,291.28,163.45Zm-2.61.21a.9.9,0,0,0-.92-1,1,1,0,0,0,0,2A.9.9,0,0,0,288.67,163.66Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M298.73,163.2v2.25h-1.14v-2.07c0-.64-.28-.93-.74-.93s-.87.33-.87,1v2h-1.14v-2.07c0-.64-.27-.93-.75-.93s-.86.33-.86,1v2h-1.14v-3.93h1.09V162a1.58,1.58,0,0,1,1.23-.52,1.49,1.49,0,0,1,1.3.65,1.73,1.73,0,0,1,1.41-.65A1.52,1.52,0,0,1,298.73,163.2Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M303.23,163.21v2.24h-1.06V165a1.29,1.29,0,0,1-1.2.55c-.92,0-1.47-.51-1.47-1.19s.49-1.18,1.69-1.18h.9c0-.48-.29-.77-.9-.77a1.84,1.84,0,0,0-1.13.37l-.41-.8a3,3,0,0,1,1.69-.48C302.54,161.46,303.23,162,303.23,163.21Zm-1.14,1v-.4h-.78c-.53,0-.7.2-.7.46s.24.48.64.48A.84.84,0,0,0,302.09,164.21Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M304.13,160.34a.65.65,0,0,1,.71-.64.64.64,0,1,1-.71.64Zm.14,1.18h1.13v3.93h-1.13Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.47,160h1.14v5.42h-1.14Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308.39,164.8a.71.71,0,0,1,1.42,0,.71.71,0,1,1-1.42,0Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M310.24,163.49a2,2,0,0,1,2.19-2,1.79,1.79,0,0,1,1.76,1l-.88.47a1.05,1.05,0,1,0-.89,1.64,1,1,0,0,0,.89-.54l.88.48a1.81,1.81,0,0,1-1.76,1A2,2,0,0,1,310.24,163.49Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M314.51,163.49a2.16,2.16,0,1,1,2.16,2A2,2,0,0,1,314.51,163.49Zm3.16,0a1,1,0,1,0-1,1.09A1,1,0,0,0,317.67,163.49Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M326.23,163.2v2.25h-1.14v-2.07c0-.64-.29-.93-.75-.93s-.87.33-.87,1v2h-1.14v-2.07c0-.64-.27-.93-.74-.93s-.86.33-.86,1v2h-1.14v-3.93h1.08V162a1.6,1.6,0,0,1,1.24-.52,1.46,1.46,0,0,1,1.29.65,1.76,1.76,0,0,1,1.42-.65A1.52,1.52,0,0,1,326.23,163.2Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.57,190.59l1.85,1-.83,1.39-1.87-1.1,0,2.06h-1.6l0-2.08L256.31,193l-.82-1.39,1.86-1-1.86-1,.82-1.39,1.87,1.12,0-2.07h1.6l0,2.07,1.87-1.12.83,1.39Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M268.28,190.59l1.85,1L269.3,193l-1.87-1.1,0,2.06h-1.59l0-2.08L264,193l-.82-1.39,1.85-1-1.85-1,.82-1.39,1.87,1.12,0-2.07h1.59l0,2.07,1.87-1.12.83,1.39Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M276,190.59l1.85,1L277,193l-1.86-1.1,0,2.06h-1.6l0-2.08L271.72,193l-.81-1.39,1.85-1-1.85-1,.81-1.39,1.87,1.12,0-2.07h1.6l0,2.07,1.86-1.12.84,1.39Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.69,190.59l1.85,1-.83,1.39-1.87-1.1,0,2.06h-1.6l0-2.08L279.43,193l-.82-1.39,1.86-1-1.86-1,.82-1.39,1.87,1.12,0-2.07h1.6l0,2.07,1.87-1.12.83,1.39Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.4,190.59l1.85,1-.83,1.39-1.87-1.1,0,2.06H289l0-2.08L287.14,193l-.82-1.39,1.85-1-1.85-1,.82-1.39L289,189.3l0-2.07h1.59l0,2.07,1.87-1.12.83,1.39Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M299.11,190.59l1.85,1-.83,1.39-1.87-1.1,0,2.06h-1.6l0-2.08L294.84,193l-.81-1.39,1.85-1-1.85-1,.81-1.39,1.87,1.12,0-2.07h1.6l0,2.07,1.87-1.12.83,1.39Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.81,190.59l1.85,1-.83,1.39-1.87-1.1,0,2.06h-1.6l0-2.08L302.55,193l-.82-1.39,1.86-1-1.86-1,.82-1.39,1.87,1.12,0-2.07H306l0,2.07,1.87-1.12.83,1.39Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M314.52,190.59l1.85,1-.83,1.39-1.87-1.1,0,2.06h-1.59l0-2.08L310.26,193l-.82-1.39,1.85-1-1.85-1,.82-1.39,1.87,1.12,0-2.07h1.59l0,2.07,1.87-1.12.83,1.39Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.46,
    y: 216.28,
    width: 161.78,
    height: 89.9,
    rx: 6.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M398.8,335.62s.43,0,1.25-.15a6.48,6.48,0,0,0,3.21-1.75,6.34,6.34,0,0,0,1.45-2.28,6.71,6.71,0,0,0,.36-1.53c0-.54,0-1.12,0-1.72,0-2.4,0-5.17,0-8.28,0-12.47-.05-30.49-.08-52.76,0-2.79,0-5.64,0-8.55v-4.42c0-1.49.15-3-.46-4.38a6.18,6.18,0,0,0-5.11-3.84c-.74-.05-1.56,0-2.34,0h-9.65l-41.82,0-95.82,0a6.12,6.12,0,0,0-5.14,2.78,6.05,6.05,0,0,0-1,2.84c-.05,1,0,2.1,0,3.14V291.7q0,12,0,23.6v11.44c0,.94,0,1.89,0,2.81a6.29,6.29,0,0,0,.7,2.58,6.22,6.22,0,0,0,4.14,3.11,12.57,12.57,0,0,0,2.69.14h39.07l36.44,0,52.76.08,14.34.05,3.73,0,1.28,0-1.28,0-3.73,0-14.34.05-52.76.08-36.44,0H251.18a13.24,13.24,0,0,1-2.79-.15,6.65,6.65,0,0,1-4.46-3.36,6.57,6.57,0,0,1-.77-2.78c0-1,0-1.88,0-2.83,0-3.77,0-7.59,0-11.44V291.7q0-12,0-24.45v-12.5c0-1.06,0-2.08,0-3.18a6.65,6.65,0,0,1,1-3.08,6.81,6.81,0,0,1,2.4-2.22,6.92,6.92,0,0,1,3.18-.81l95.82,0,41.82,0h9.65c.8,0,1.56,0,2.38,0a6.58,6.58,0,0,1,2.3.68,6.65,6.65,0,0,1,3.15,3.42,6.35,6.35,0,0,1,.46,2.28c0,.75,0,1.5,0,2.25v4.42q0,4.36,0,8.55c0,22.27-.07,40.29-.09,52.76,0,3.11,0,5.88,0,8.28,0,.6,0,1.17,0,1.73a6.72,6.72,0,0,1-.38,1.56,6.37,6.37,0,0,1-1.49,2.31,6.45,6.45,0,0,1-3.28,1.73,6,6,0,0,1-.94.1Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M299.76,277.49v1.12h-4.68v-6h4.56v1.12h-3.17V275h2.8v1.09h-2.8v1.4Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.42,272.57v6h-1.15l-3-3.67v3.67h-1.38v-6H302l3,3.67v-3.67Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M309.11,273.71h-1.94v-1.14h5.27v1.14H310.5v4.9h-1.39Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M317.87,277.49v1.12h-4.68v-6h4.57v1.12h-3.18V275h2.81v1.09h-2.81v1.4Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M322.84,278.61l-1.17-1.68h-1.28v1.68H319v-6h2.62c1.61,0,2.62.83,2.62,2.19a2,2,0,0,1-1.24,1.91l1.35,1.94Zm-1.31-4.9h-1.14v2.1h1.14c.85,0,1.28-.39,1.28-1.05S322.38,273.71,321.53,273.71Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M327.4,275.59a3.33,3.33,0,0,1,5.77-2.06l-.9.83a2,2,0,0,0-1.52-.71,1.94,1.94,0,0,0,0,3.87,1.92,1.92,0,0,0,1.52-.71l.9.83a3.32,3.32,0,0,1-5.77-2.05Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333.61,275.59a3.31,3.31,0,1,1,3.3,3.13A3.12,3.12,0,0,1,333.61,275.59Zm5.19,0a1.89,1.89,0,1,0-1.89,1.93A1.85,1.85,0,0,0,338.8,275.59Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M341.28,272.57H344a3,3,0,1,1,0,6h-2.74Zm2.67,4.89a1.87,1.87,0,1,0,0-3.74h-1.27v3.74Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M353.09,277.49v1.12h-4.68v-6H353v1.12H349.8V275h2.81v1.09H349.8v1.4Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 222.25,
    y: 258.82,
    width: 22.59,
    height: 30.77,
    rx: 3.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 250.46,
    y: 258.82,
    width: 22.59,
    height: 30.77,
    rx: 3.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 278.67,
    y: 258.82,
    width: 22.59,
    height: 30.77,
    rx: 3.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 306.87,
    y: 258.82,
    width: 22.59,
    height: 30.77,
    rx: 3.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.08,
    y: 258.82,
    width: 22.59,
    height: 30.77,
    rx: 3.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274.4,306c0,2.19-1.7,3.62-4,3.62-3.16,0-4.83-2.27-4.83-6,0-4.06,2.17-6.16,5.34-6.16a5.28,5.28,0,0,1,2.73.62l-.36.7a4.5,4.5,0,0,0-2.37-.55c-2.69,0-4.46,1.77-4.46,5.26a10.33,10.33,0,0,0,.1,1.44,3.77,3.77,0,0,1,3.83-2.47C272.78,302.46,274.4,303.86,274.4,306Zm-.88,0c0-1.71-1.23-2.83-3.26-2.83a3,3,0,0,0-3.33,2.87c0,1.41,1.18,2.81,3.43,2.81A2.85,2.85,0,0,0,273.52,306Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302.3,306.23h-2.52v3.33h-.86v-3.33h-6.85v-.63l6.52-8.05h1l-6.4,7.91h5.77v-2.93h.84v2.93h2.52Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M331.39,311.27a52.83,52.83,0,0,1-10.47,0,52.83,52.83,0,0,1,10.47,0Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 217.73,
    cy: 225.25,
    r: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.17,254.7a2.45,2.45,0,1,1-2.45-2.45A2.45,2.45,0,0,1,263.17,254.7Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 231.72,
    cy: 225.25,
    r: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M405.42,261.6c0,.14-36.23.26-80.9.26s-80.9-.12-80.9-.26,36.21-.26,80.9-.26S405.42,261.45,405.42,261.6Z",
    transform: "translate(-35.93 -29.44)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Message"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.7,135.35H145.8a4.05,4.05,0,0,0-4.05,4.06v35.48a4,4,0,0,0,4.05,4.05h32.68l6.94,8.91,5.79-8.91H223.7a4.05,4.05,0,0,0,4.05-4.05V139.41A4.06,4.06,0,0,0,223.7,135.35Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.7,135.35h.38a4.22,4.22,0,0,1,1.11.25,4,4,0,0,1,1.54,1A4.06,4.06,0,0,1,227.8,139c.08,3.86.06,9.48.09,16.6,0,3.56,0,7.49,0,11.75,0,2.14,0,4.35,0,6.65a9.63,9.63,0,0,1-.08,1.76,4.3,4.3,0,0,1-.74,1.68,4.25,4.25,0,0,1-3.23,1.74l-32.68,0,.2-.1c-1.82,2.79-3.78,5.82-5.78,8.9l-.19.29-.22-.27-6.94-8.9.2.1H147c-.57,0-1.1,0-1.71,0a4.33,4.33,0,0,1-3.71-3.34,7.67,7.67,0,0,1-.11-1.7V159.51q0-6.39,0-12.53v-7.57a4.25,4.25,0,0,1,.29-1.54,4.34,4.34,0,0,1,2-2.28,4.24,4.24,0,0,1,1.47-.44,14.8,14.8,0,0,1,1.48,0h8.51l10.78,0,19.34,0,28,.08,7.61.05,2,0,.68,0-.68,0-2,0-7.61.05-28,.08-19.34,0H146.79c-.48,0-1,0-1.43,0a3.71,3.71,0,0,0-1.3.4,3.81,3.81,0,0,0-1.81,2,3.75,3.75,0,0,0-.26,1.37v1.5c0,2,0,4,0,6.07v12.53q0,6.38,0,13v1.66a6.88,6.88,0,0,0,.09,1.59,3.81,3.81,0,0,0,3.27,2.93c.51.05,1.1,0,1.65,0H178.6l.08.1,6.94,8.9-.41,0,5.79-8.9.07-.11h.14l32.66,0a3.77,3.77,0,0,0,2.93-1.56,3.73,3.73,0,0,0,.68-1.52,9.44,9.44,0,0,0,.08-1.69c0-2.3,0-4.51,0-6.65,0-4.26,0-8.19,0-11.75,0-7.1,0-12.72.05-16.59a4,4,0,0,0-1-2.25,4.05,4.05,0,0,0-1.49-1.05A5,5,0,0,0,223.7,135.35Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.16,145.37v1.31h-.85v-1.32L167.87,143h.91l1,1.64,1-1.64h.84Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.58,144.83a2,2,0,1,1,2,1.91A1.91,1.91,0,0,1,171.58,144.83Zm3.18,0A1.16,1.16,0,1,0,173.6,146,1.13,1.13,0,0,0,174.76,144.83Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M176.25,145.05V143h.86v2c0,.7.31,1,.82,1s.83-.29.83-1v-2h.85v2.07a1.68,1.68,0,1,1-3.36,0Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M182.82,146.68l-.71-1h-.79v1h-.86V143h1.6c1,0,1.61.51,1.61,1.34a1.2,1.2,0,0,1-.76,1.17l.83,1.19Zm-.8-3h-.7V145h.7c.52,0,.78-.25.78-.65S182.54,143.67,182,143.67Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185.62,144.83a2,2,0,0,1,3.54-1.26l-.55.51a1.19,1.19,0,0,0-.94-.44,1.19,1.19,0,0,0,0,2.37,1.18,1.18,0,0,0,.94-.43l.55.5a2,2,0,0,1-3.54-1.25Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189.43,144.83a2,2,0,1,1,2,1.91A1.91,1.91,0,0,1,189.43,144.83Zm3.18,0a1.16,1.16,0,1,0-1.16,1.18A1.13,1.13,0,0,0,192.61,144.83Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M194.13,143h1.69a1.86,1.86,0,1,1,0,3.7h-1.69Zm1.64,3a1.15,1.15,0,1,0,0-2.3H195V146Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M201.38,146v.69h-2.87V143h2.8v.68h-1.95v.81h1.72v.67h-1.72V146Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.92,
    y: 121.13,
    width: 69.79,
    height: 20.34,
    rx: 3.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164,162a3,3,0,0,1-3.28,3c-2.58,0-3.95-1.86-3.95-4.94,0-3.34,1.77-5.05,4.38-5.05a4.38,4.38,0,0,1,2.23.5l-.29.58a3.69,3.69,0,0,0-1.94-.45c-2.21,0-3.66,1.45-3.66,4.31a7.83,7.83,0,0,0,.08,1.18,3.09,3.09,0,0,1,3.14-2C162.72,159.06,164,160.21,164,162Zm-.72,0c0-1.41-1-2.32-2.67-2.32a2.48,2.48,0,0,0-2.73,2.35c0,1.15,1,2.31,2.82,2.31A2.33,2.33,0,0,0,163.32,162Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M177.11,162.16h-2.06v2.73h-.71v-2.73h-5.61v-.52l5.35-6.6h.8l-5.25,6.48h4.73v-2.4h.69v2.4h2.06Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.05,162.11c0,1.64-1.18,2.85-3.45,2.85a4.72,4.72,0,0,1-3.47-1.33l.36-.55a4.21,4.21,0,0,0,3.11,1.21c1.77,0,2.72-.84,2.72-2.18s-.9-2.18-2.87-2.18h-.62v-.52l2.91-3.73h-5.25V155h6.18v.5l-3,3.79C187,159.38,188.05,160.51,188.05,162.11Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M200,155v.5l-4.23,9.35h-.79l4.19-9.21h-5.53v1.89h-.7V155Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205,160c0-3.08,1.59-5,3.85-5s3.86,1.91,3.86,5-1.59,5-3.86,5S205,163,205,160Zm7,0c0-2.74-1.28-4.33-3.14-4.33s-3.14,1.59-3.14,4.33,1.28,4.33,3.14,4.33S212,162.7,212,160Z",
    transform: "translate(-35.93 -29.44)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M419.4,417.52c13.09-5.56,28.25-16.49,35-29.9a74.62,74.62,0,0,0-35,29.9",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M422.19,396.71c13.09-5.55,28.25-16.48,35-29.89a74.51,74.51,0,0,0-35,29.89",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M426,376.48c13.1-5.56,28.25-16.49,35-29.89a74.54,74.54,0,0,0-35,29.89",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M430.72,355.3C443.07,348,456.84,335,462,320.82a77,77,0,0,0-31.25,34.48",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M435.8,339.09c9-11.77,17.39-29.29,17.28-44.47a82.7,82.7,0,0,0-17.28,44.47",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M433.28,346.8c-1.82-15.92-8-35.93-18.52-47.87a97.27,97.27,0,0,0,18.52,47.87",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M429.05,364.21c-3.2-16.41-11.3-36.71-23.24-48.22a101,101,0,0,0,23.24,48.22",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M424.19,385.44C421,369,412.88,348.73,401,337.22a101,101,0,0,0,23.24,48.22",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M420.29,411.51c-3.21-16.41-11.31-36.71-23.24-48.22a101,101,0,0,0,23.24,48.22",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M436.41,336a.72.72,0,0,0-.1.25c-.07.19-.15.43-.25.73-.22.69-.53,1.64-.91,2.84-.79,2.47-1.85,6.06-3.1,10.52s-2.63,9.79-4.05,15.74-2.82,12.54-4.14,19.48-2.35,13.6-3.22,19.66-1.49,11.54-1.94,16.14-.77,8.34-.93,10.93c-.08,1.26-.14,2.25-.19,3,0,.32,0,.57,0,.78a.86.86,0,0,0,0,.26.82.82,0,0,0,.05-.26c0-.2,0-.46.08-.77.07-.72.17-1.71.29-3,.22-2.57.59-6.3,1.09-10.9s1.19-10.06,2.05-16.11,2-12.69,3.26-19.63,2.72-13.51,4.09-19.47,2.73-11.29,3.94-15.76,2.21-8.07,2.94-10.55l.82-2.87c.08-.3.14-.55.2-.75A1,1,0,0,0,436.41,336Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.8,339.09",
    transform: "translate(-35.93 -29.44)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M413,426.18c5.55-11.62,9.59-28,6.87-40.73A72.23,72.23,0,0,0,413,426.18",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M403.79,411.13c5.55-11.63,9.59-28,6.86-40.73a72.13,72.13,0,0,0-6.86,40.73",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M395.51,395.82c5.55-11.63,9.59-28,6.86-40.73a72.13,72.13,0,0,0-6.86,40.73",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M387.35,379.31c4.13-12.3,6.2-29.08,2-41.35a72.71,72.71,0,0,0-2,41.35",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M382,365.79c-.41-13.09-4.26-29.49-12.39-39.16A71,71,0,0,0,382,365.79",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M384.49,372.28c-9.63-9.08-24.27-18.11-37.43-19.29a72.49,72.49,0,0,0,37.43,19.29",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M391,386.06c-10.79-8.56-26.83-16.58-40.69-16.61A75.58,75.58,0,0,0,391,386.06",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M399.1,402.67c-10.79-8.55-26.82-16.58-40.68-16.61a75.58,75.58,0,0,0,40.68,16.61",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M410.41,421.79c-10.79-8.56-26.83-16.58-40.69-16.62a75.52,75.52,0,0,0,40.69,16.62",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M380.78,363.42s0,.07.06.21l.22.62.9,2.35c.79,2,2,5,3.53,8.58,3.08,7.19,7.65,17,13.32,27.54,2.84,5.25,5.69,10.19,8.35,14.62s5.19,8.37,7.36,11.63,4,5.87,5.24,7.65l1.48,2,.39.52c.09.12.14.18.15.17a1.75,1.75,0,0,0-.11-.2l-.35-.55c-.35-.51-.81-1.21-1.4-2.09-1.24-1.81-3-4.45-5.11-7.73s-4.6-7.24-7.26-11.67-5.47-9.38-8.31-14.63C393.57,392,389,382.2,385.81,375c-1.58-3.58-2.83-6.49-3.67-8.51l-1-2.32-.27-.6A.92.92,0,0,0,380.78,363.42Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "350.65 398.14 405.81 398.14 405.81 408.78 400.14 408.78 395.37 439.1 361.27 439.1 356.36 408.78 350.65 408.78 350.65 398.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M386.58,438c0-.14,12.26-.26,27.38-.26s27.38.12,27.38.26-12.25.25-27.38.25S386.58,438.14,386.58,438Z",
    transform: "translate(-35.93 -29.44)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "34.68 439.11 25.73 439.11 22.41 398.81 32.95 398.81 34.68 439.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "112.27 439.11 121.23 439.11 124.55 398.81 114 398.81 112.27 439.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.63,433.36l-115.24,2.7-3.5-74.43a12.77,12.77,0,0,1,12.76-13.38h98.19a12.78,12.78,0,0,1,12.75,13.66Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.54,361.38l-.32,0-.95,0-3.63.06-13.36,0c-11.28,0-26.86-.1-44.06.3-17.21.57-32.81.47-44.08.3-5.64-.09-10.21-.2-13.36-.3l-3.63-.12-.94,0a1.25,1.25,0,0,1-.32,0l.32,0h.94l3.63,0,13.36.13c11.28.08,26.86.12,44.07-.46,17.21-.39,32.79-.21,44.07-.13l13.36.11,3.63.05.95,0Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.92,349.41a26.67,26.67,0,0,0-7.48,2.25,26.31,26.31,0,0,0-6.21,4.74,6.9,6.9,0,0,1,1.43-1.86,17.29,17.29,0,0,1,9.92-5.06A6.68,6.68,0,0,1,89.92,349.41Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M137.32,214.08l14.08,25.73L172,228.27l10,3.31S156.76,259,152.65,260.43s-11.89,1.66-16.33-3.91c-4-5.07-15.84-31.67-15.84-31.67Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.31,197.28a1.67,1.67,0,0,0-1.52-.6L184,198a3,3,0,0,0-2.09,1.36L161.5,230.71l1.56.87,10.86-.34,21.7-33.57Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.36,201.35a.7.7,0,1,0,.07-.84A.62.62,0,0,0,188.36,201.35Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M195.62,197.67a12,12,0,0,1-1.9.37l-5.2.81-3.59.52a2.05,2.05,0,0,0-1.52.9l-1.16,1.8c-1.61,2.47-3.36,5.18-5.2,8-3.71,5.68-7.09,10.81-9.57,14.51L164.53,229a12.7,12.7,0,0,1-1.15,1.56,10.75,10.75,0,0,1,1-1.68l2.8-4.46c2.39-3.76,5.71-8.92,9.42-14.6,1.86-2.83,3.63-5.53,5.24-8,.41-.61.81-1.21,1.19-1.8a2.54,2.54,0,0,1,1.87-1.08l3.61-.46,5.23-.62A11.94,11.94,0,0,1,195.62,197.67Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M184.73,208.86s-.87-.15-1.35,2.24-2,9.25-2,9.25l-4.58-2.43-5.74.75s-1.25,1.15-.33,1.78,4.54,1.27,4.54,1.27l2.67,3.85-7.67-3.7s-2.56.67-1.81,2.23,5.92,6.45,5.92,6.45l-3.84-.29L166,227.48s-1.4.07-.88,1.26,5.28,5.51,5.28,5.51l5.76,2.8s3.15-.25,3.45-1.18a11,11,0,0,0,.38-2.24s1.67-.45,2-1.26a5,5,0,0,0,.11-2.09s2.62.46,2.95-1a16.58,16.58,0,0,0-.22-5.46c-.26-1.13,1.12-11.58,1-11.89S186.38,208.17,184.73,208.86Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M179.76,235.89a3.27,3.27,0,0,1-1.5.46,10.13,10.13,0,0,1-7.27-1.73c-.79-.57-1.18-1-1.13-1.09s1.93,1.43,4.73,2.08S179.73,235.71,179.76,235.89Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M178.4,233.82c-.09.13-1.12-.4-2.21-1.3s-1.81-1.79-1.7-1.9,1,.57,2.08,1.45S178.49,233.68,178.4,233.82Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M181.43,228.85c-.09.13-1.11-.39-2.13-1.34s-1.62-1.91-1.5-2,.92.67,1.9,1.58S181.52,228.71,181.43,228.85Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M184.62,224.84c-.16.07-.74-1-1.65-2.19s-1.8-2-1.7-2.16,1.2.54,2.16,1.8A4.52,4.52,0,0,1,184.62,224.84Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M188.51,410.3a2,2,0,0,0,0-.95,6.32,6.32,0,0,0-1-2.41,3.85,3.85,0,0,0-.57-.69,1.08,1.08,0,0,0-1.08-.24.76.76,0,0,0-.47.47,1,1,0,0,0,0,.64,6.27,6.27,0,0,0,.5,1c.37.63.68,1.25,1.16,2a1.35,1.35,0,0,0,1.27.57,2.86,2.86,0,0,0,1.23-.54,10.67,10.67,0,0,0,1.8-1.67,10.52,10.52,0,0,0,.72-.93,3.1,3.1,0,0,0,.53-1.06,1,1,0,0,0-.54-1.16,1.21,1.21,0,0,0-1.15.26,7,7,0,0,0-1.2,1.36,9.2,9.2,0,0,0-1.19,2.3,2.22,2.22,0,0,0-.2.92,18.25,18.25,0,0,1,1.71-3,7.38,7.38,0,0,1,1.16-1.22c.23-.16.51-.27.68-.18a.5.5,0,0,1,.22.59,2.74,2.74,0,0,1-.47.86c-.21.3-.44.59-.68.88a11.27,11.27,0,0,1-1.72,1.57,2.28,2.28,0,0,1-1,.44.8.8,0,0,1-.77-.36c-.39-.57-.77-1.28-1.14-1.87-.17-.31-.38-.61-.48-.86s0-.45.15-.53c.43-.17.86.32,1.15.73A9,9,0,0,1,188.51,410.3Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "128.01 381.7 115.81 408.14 96.11 399.05 108.74 366.32 128.01 381.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M154,435.82l-7.13,13.6s18.25,18.87,16.54,23.09l-42.9-20.57,11.78-27.27Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.54,441.2a2,2,0,0,0-2.17,1.42,1.86,1.86,0,0,0,1.39,2.16,2.05,2.05,0,0,0,2.29-1.51,1.94,1.94,0,0,0-1.7-2.09",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.55,451.94l1.78-3.42,40.47,21s1.51,1.74.65,3Z",
    transform: "translate(-35.93 -29.44)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147.71,449.53c-.1.21-1.2-.2-2.55,0s-2.33.8-2.48.62.74-1.23,2.38-1.42S147.85,449.36,147.71,449.53Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.32,453.55c0,.23-1.13.15-2.26.69s-1.79,1.39-2,1.28.23-1.36,1.66-2S151.41,453.35,151.32,453.55Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.29,460.16c-.21,0,0-1.23,1.09-2.12s2.29-.88,2.29-.66-.89.54-1.78,1.28S151.51,460.24,151.29,460.16Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149.76,444.3c-.18.15-1-.6-2.22-1.09s-2.33-.56-2.35-.79,1.22-.55,2.65,0S149.94,444.18,149.76,444.3Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158.06,432.29l32.17-80.49s-.73-13.74-3.26-18.07-79.15-29.64-79.15-29.64-19.51-4.7-32.53,0-22.77,21-21,30,9.43,15.67,9.43,15.67l56.35,1.68,30.71,11.2-20.68,59.27Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "150.74 347.85 151.47 376.96 129.78 377.49 126.66 342.55 150.74 347.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M188.69,403.8l-.4,15.35s24.7,8.87,25,13.42l-47.57.48-1.47-29.67Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.56,417.24a1.94,1.94,0,0,0-1.32,2.23,1.87,1.87,0,0,0,2.2,1.33,2.05,2.05,0,0,0,1.38-2.37,1.93,1.93,0,0,0-2.44-1.13",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.75,433.05l.09-3.86,45.58,1s2.12.9,1.9,2.4Z",
    transform: "translate(-35.93 -29.44)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189.06,418.9c0,.23-1.17.35-2.3,1.11s-1.74,1.74-1.95,1.65.12-1.44,1.51-2.33S189.11,418.69,189.06,418.9Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M194.07,420.91c.06.23-.95.63-1.73,1.62s-1,2-1.22,2-.4-1.32.6-2.54S194.06,420.69,194.07,420.91Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197,426.86c-.21.05-.54-1.11,0-2.39s1.67-1.79,1.77-1.6-.57.88-1,1.93S197.19,426.83,197,426.86Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M188.58,413.3c-.09.21-1.16-.1-2.47,0s-2.33.53-2.46.33.85-1,2.4-1.13S188.7,413.11,188.58,413.3Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174,296.45s13-1,14.44,13.06,2.86,79.88,2.86,79.88L161,391.92l-4.7-67.23-48.43-20.6S165.33,294.65,174,296.45Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.46,277.43s7.88,22.11,6.38,24.57-21.77,12.6-21.77,12.6L54.33,334.09s-5.21-8.29-5.21-21,17.65-35.64,17.65-35.64Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M105.42,303a1.31,1.31,0,0,0,.24.13l.72.33,2.81,1.25,10.55,4.6,36.41,15.67-.17-.23c.46,6.64,1,13.81,1.47,21.23,1.24,17.35,2.38,33.34,3.28,46v.23l.23,0,22.12-1.94,6.09-.57,1.59-.16.54-.08a3.27,3.27,0,0,0-.55,0l-1.59.1-6.1.45-22.14,1.74.25.21c-.87-12.65-2-28.65-3.16-46-.52-7.42-1-14.59-1.5-21.23v-.16l-.15-.07L119.87,309l-10.61-4.44-2.84-1.17-.74-.29A1.8,1.8,0,0,0,105.42,303Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M65.07,305.17a7,7,0,0,0,1.43-.38l3.82-1.24a84.31,84.31,0,0,1,12.78-3.23,37.65,37.65,0,0,1,13.09.17c3.3.69,5.2,1.63,5.24,1.52a5.88,5.88,0,0,0-1.32-.67,23.65,23.65,0,0,0-3.83-1.24A35.36,35.36,0,0,0,83,299.76a71.92,71.92,0,0,0-12.83,3.41c-1.6.57-2.88,1.06-3.77,1.41A8.83,8.83,0,0,0,65.07,305.17Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M72.24,293.52a36.49,36.49,0,0,1,4.44,0c1.37.09,3,.3,4.8.51s3.79.46,5.85.85a27,27,0,0,1,9.94,3.69,32.37,32.37,0,0,1,3.45,2.77,4.14,4.14,0,0,0-.74-.95,15.31,15.31,0,0,0-2.49-2.16,25.49,25.49,0,0,0-10.06-3.91c-2.08-.39-4.08-.62-5.89-.81s-3.45-.35-4.84-.39a18.94,18.94,0,0,0-3.28.14A4.23,4.23,0,0,0,72.24,293.52Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.65,115.88c-5.83-1-11,1.25-15.89,4.54a30.1,30.1,0,0,0-11.84,32.13,23.16,23.16,0,0,0,11.4,14.18c7.59,3.85,17.3,2.51,24.1-2.63s10.67-13.63,11-22.14A28.22,28.22,0,0,0,109,125.23a21.42,21.42,0,0,0-14.32-9.35",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.05,135.73c.86-2.24.52-4.73.86-7.1.75-5.21,5-9.39,9.8-11.42,4.52-1.89,10-1.48,15.48.28a20.78,20.78,0,0,1,9.73,6.34,16.33,16.33,0,0,1,3,14.7l-26.66-3.88c-2.5,2.06-5.06,4.17-8.09,5.32a5.55,5.55,0,0,1-2.78.44,2.48,2.48,0,0,1-2.07-1.71C77.08,137.69,77.68,136.7,78.05,135.73Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M104.76,124.85l-23.28,4.94A4.35,4.35,0,0,0,77.42,134l.28,50.39a15.71,15.71,0,0,0,3.28,9.5l2.22,2.86c5.07,6.53,15.32,5.87,19.19-1.43a5.48,5.48,0,0,0,.54-1.32c.07-.45.19-.75.21-1.13l.45-4.92c.22-4.48.26-9,.26-9s9.53-1.2,12-13.48c1.21-6.1,1.29-16.19,1.09-24.44C116.73,133.64,112.18,124.36,104.76,124.85Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.37,150.53a1.58,1.58,0,0,1-1.59,1.53,1.51,1.51,0,0,1-1.58-1.49,1.6,1.6,0,0,1,1.59-1.54A1.52,1.52,0,0,1,113.37,150.53Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.53,146.22c-.21.2-1.37-.73-3.08-.79s-3,.74-3.16.52.12-.46.68-.83a4.32,4.32,0,0,1,2.55-.68,4.15,4.15,0,0,1,2.43.89C114.46,145.76,114.63,146.14,114.53,146.22Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.09,150.14a1.58,1.58,0,0,1-1.59,1.54,1.51,1.51,0,0,1-1.57-1.49,1.58,1.58,0,0,1,1.58-1.54A1.52,1.52,0,0,1,98.09,150.14Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.34,145.81c-.21.2-1.37-.74-3.08-.8s-3,.74-3.16.53.12-.46.69-.84a4.41,4.41,0,0,1,2.54-.68,4.22,4.22,0,0,1,2.44.9C98.27,145.34,98.44,145.72,98.34,145.81Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.45,158.77a12.46,12.46,0,0,1,2.79-.39c.44,0,.85-.1.94-.39a2.26,2.26,0,0,0-.24-1.3c-.37-1.07-.76-2.19-1.16-3.37-1.61-4.79-2.75-8.72-2.56-8.78s1.66,3.77,3.26,8.56c.38,1.18.75,2.3,1.1,3.38a2.49,2.49,0,0,1,.16,1.72,1.12,1.12,0,0,1-.74.61,3.4,3.4,0,0,1-.74.07A10.63,10.63,0,0,1,103.45,158.77Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M103.85,179a31.39,31.39,0,0,1-16.37-5.05s3.82,8.71,16.23,8Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102.57,162.85a3.06,3.06,0,0,0-2.71-1.24,2.8,2.8,0,0,0-2,1,1.78,1.78,0,0,0-.22,2,2.07,2.07,0,0,0,2.21.65,6.33,6.33,0,0,0,2.23-1.22,1.8,1.8,0,0,0,.51-.48.58.58,0,0,0,0-.64",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.39,159.76c.28,0,.21,1.84,1.74,3.22s3.51,1.25,3.52,1.51c0,.11-.46.34-1.29.33a4.61,4.61,0,0,1-2.94-1.16A4,4,0,0,1,98.08,161C98,160.19,98.26,159.74,98.39,159.76Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.24,140.75c-.18.46-1.88.17-3.89.33s-3.64.65-3.89.22c-.11-.2.18-.63.85-1.05a6.46,6.46,0,0,1,2.92-.89,6.38,6.38,0,0,1,3,.47C98,140.15,98.32,140.53,98.24,140.75Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.32,138.75c-.31.38-1.47-.07-2.88-.15s-2.62.16-2.88-.25c-.12-.2.09-.58.62-.93a4,4,0,0,1,2.38-.54,4,4,0,0,1,2.27.86C114.31,138.16,114.46,138.57,114.32,138.75Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.78,132.13c2.42-7.09,13-16.75,20.42-16.08L106,123.44a11.5,11.5,0,0,1-8,8.65c-2.13.6-4.67.73-6,2.52s-.62,4.54-1.85,6.42c-1.71,2.62-6.22,2.4-7.52,5.24-.56,1.24-.31,2.74-.9,4-.78,1.64-5,3.65-6.73,3.07s-1.67-3.53-2.2-5.09a8.1,8.1,0,0,1-.14-5.48C73.52,139.26,72.63,135.51,73.78,132.13Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M80.12,154.87c0-.92-1-3.13-1.85-3.31-2.41-.47-6.79-.44-7.07,5.72-.38,8.42,8.15,7.06,8.18,6.82S80,158.05,80.12,154.87Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M77,160.8s-.15.09-.41.19a1.46,1.46,0,0,1-1.09,0c-.88-.37-1.56-1.82-1.54-3.33a5,5,0,0,1,.51-2.09,1.7,1.7,0,0,1,1.16-1.07.73.73,0,0,1,.84.44c.1.24,0,.41.09.42s.18-.13.13-.48a.88.88,0,0,0-.3-.54,1.1,1.1,0,0,0-.81-.26,2.08,2.08,0,0,0-1.59,1.24,5,5,0,0,0-.61,2.32c0,1.7.77,3.33,2,3.74a1.59,1.59,0,0,0,1.35-.16C76.92,161,77,160.81,77,160.8Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72,130h0c0-2.64-3.26-4.36-5.83-5a11,11,0,0,0-7.59,1.45c-1.35.74-2.71,1.8-3,3.31s1.15,3.31,2.59,2.77A5,5,0,1,0,63,141.06a11.14,11.14,0,0,1-4.38,6A12.51,12.51,0,0,0,72,130Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.14,143.34a7.5,7.5,0,0,1-.32-2.53,18.54,18.54,0,0,1,3.88-11.5,7.22,7.22,0,0,1,1.78-1.82,27.83,27.83,0,0,0-4.16,7.42C65.77,139.41,66.33,143.35,66.14,143.34Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.54,120.9c.77,3.43,6,7.82,8.27,10.49,4.36,5.09,5.22,6.78,5.18,18.17,2.06-3.93,3.64-7.79,3.48-12.22a18.38,18.38,0,0,0-4.88-12.08,14.28,14.28,0,0,0-12-4.36",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.25,214.58s-9.08-15.13-11.6-18.19a20.19,20.19,0,0,0-7.43-5.45,15.58,15.58,0,0,0-3.53-1.05L103.63,187s0,8.91-9.35,9.46S77.09,184,77.09,184,62,186.34,58.4,188.2,49.12,192.41,46,208l-2.19,15.28,26,2.4,2.49,38.64,12.89,9s35.75,9.29,38,9.9,3-57.52,3-57.52S135.45,219.79,139.25,214.58Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M122.13,208.08a5.59,5.59,0,0,1,.51,1.12c.29.73.67,1.8,1.09,3.14a61.12,61.12,0,0,1,2.66,21.72c-.08,1.4-.19,2.53-.31,3.31a5.64,5.64,0,0,1-.21,1.2,5.21,5.21,0,0,1,0-1.22c.05-.78.11-1.91.14-3.31a75.21,75.21,0,0,0-.5-10.9,74.4,74.4,0,0,0-2.14-10.69c-.37-1.35-.7-2.44-.94-3.18A5.83,5.83,0,0,1,122.13,208.08Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M121,271.37l-49-10.66-2.26-35-21.77-2s.81,23.92,1.64,31c1.21,10.23,7.25,24.19,10.79,27s62.75,1.53,62.75,1.53Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M148.81,277.71a1.88,1.88,0,0,1-1.82,1.06,2,2,0,0,1-.47-.09c-1.09-.35-1-2.56-1-2.56l-5.18-.84s-6.75,4.35-9.15,7.23-8.52.55-8.52.55L120.55,272l9.55-8.63s-.58.51.08-1.1,3.65-1,3.65-1c.47-.8,2.43-1.08,2.43-1.08l8.38,1a5.73,5.73,0,0,1,4.19,2.64l3.55,5.61s1.87,4,1.57,5a1.68,1.68,0,0,1-2,1.1s-.41,2.66-1.11,2.75a5.79,5.79,0,0,1-2.07-.5Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M131,269.77c0,.09,1.12,0,2.91.06a25.45,25.45,0,0,1,6.83,1.28,24,24,0,0,1,3.53,1.51c1,.57,2.06,1,2.39,1.77a1,1,0,0,1-.09,1,1.39,1.39,0,0,1-.63.53,2,2,0,0,1-.74.11s.26.23.8.09a1.48,1.48,0,0,0,.81-.56,1.34,1.34,0,0,0,.2-1.31,2.74,2.74,0,0,0-1-1.18c-.46-.29-.94-.6-1.47-.89a22.53,22.53,0,0,0-3.59-1.58,21.83,21.83,0,0,0-7-1.15A9.45,9.45,0,0,0,131,269.77Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M130.4,275.11c0,.16,3.42,0,7.61.26s7.55.76,7.58.6a8.26,8.26,0,0,0-2.18-.53,47.59,47.59,0,0,0-5.37-.6,48.64,48.64,0,0,0-5.41,0A8.17,8.17,0,0,0,130.4,275.11Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M148.76,277.5a3.59,3.59,0,0,0,.11-.89,19.79,19.79,0,0,0,0-2.46,10.12,10.12,0,0,0-.23-1.7,5.1,5.1,0,0,0-.82-1.82,11.5,11.5,0,0,0-3.14-3.21,15.78,15.78,0,0,0-4-2,14.76,14.76,0,0,0-3.62-.55c-1,0-1.86,0-2.44,0a2.74,2.74,0,0,0-.9.09,28.75,28.75,0,0,0,3.32.28,15.63,15.63,0,0,1,3.5.64,16.85,16.85,0,0,1,3.85,2,11.72,11.72,0,0,1,3,3.06,6.39,6.39,0,0,1,1.09,3.28C148.7,276.21,148.65,277.5,148.76,277.5Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M136.67,262.3c0,.08,1.25.12,3.25.35s5,.43,6.77,3.09a28.34,28.34,0,0,1,4.22,6.57,17.53,17.53,0,0,1,.8,3.14,2.26,2.26,0,0,0,0-.89,8.7,8.7,0,0,0-.49-2.38,24.6,24.6,0,0,0-4.17-6.77,9,9,0,0,0-1.62-1.65,5.68,5.68,0,0,0-2-.92,17.5,17.5,0,0,0-3.55-.57A13.58,13.58,0,0,0,136.67,262.3Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M133,280.73a3.66,3.66,0,0,0,.5-.38l1.4-1.13a57.51,57.51,0,0,1,5.51-3.79l-.12,0,5.18.88-.18-.22a5.44,5.44,0,0,0,.1,1.27,2.37,2.37,0,0,0,.59,1.25,1.29,1.29,0,0,0,.68.32,2,2,0,0,0,.73,0,2.08,2.08,0,0,0,1.29-.72,1.7,1.7,0,0,0,.23-.3l.05-.09,0,0v0h0l-.3.11h0l.16.06c.22.09.44.17.67.24s.46.13.71.18a2.34,2.34,0,0,0,.39,0,1,1,0,0,0,.48-.09,1.56,1.56,0,0,0,.5-.69,4.66,4.66,0,0,0,.26-.71,12,12,0,0,0,.33-1.47l-.3.21a2,2,0,0,0,1.93-.66,1.59,1.59,0,0,0,.36-1,5.32,5.32,0,0,0-.18-1,29.78,29.78,0,0,0-1.43-3.73h0v0l-1.89-3-1.2-1.89a9.84,9.84,0,0,0-1.31-1.84,5.63,5.63,0,0,0-1.88-1.25,7.17,7.17,0,0,0-2.14-.44l-7.89-.89h-.06a7.11,7.11,0,0,0-1.39.37,2.33,2.33,0,0,0-1.2.84l.29-.09a2.87,2.87,0,0,0-2.69.15,3.36,3.36,0,0,0-1.33,2.12l.06-.11-6.58,5.92-1.77,1.63a3.82,3.82,0,0,0-.59.6,4.85,4.85,0,0,0,.66-.52l1.85-1.55,6.69-5.78.05,0,0-.07a3,3,0,0,1,1.17-1.85,2.48,2.48,0,0,1,2.27-.09l.18.07.11-.16a2,2,0,0,1,1-.64,6.78,6.78,0,0,1,1.29-.33h-.07l7.89.93a6.92,6.92,0,0,1,2,.42,5,5,0,0,1,1.7,1.13,9.6,9.6,0,0,1,1.24,1.75l1.2,1.9c.65,1,1.29,2,1.89,3l0,0a27.26,27.26,0,0,1,1.41,3.64,4.22,4.22,0,0,1,.17.89,1.07,1.07,0,0,1-.25.71,1.44,1.44,0,0,1-1.41.47l-.27,0,0,.25a12.58,12.58,0,0,1-.31,1.41,2.55,2.55,0,0,1-.54,1.12.67.67,0,0,1-.21,0l-.32,0c-.21,0-.43-.1-.65-.16l-.64-.22-.15-.06h0l-.31.11h0l0,0,0,.06a1.46,1.46,0,0,1-.17.24,1.65,1.65,0,0,1-1,.57,1.37,1.37,0,0,1-.57,0,.88.88,0,0,1-.48-.2,3.24,3.24,0,0,1-.56-2.17v-.19l-.18,0-5.2-.81h-.06l-.05,0a50.38,50.38,0,0,0-5.45,3.94c-.6.51-1.05.92-1.35,1.2A2.94,2.94,0,0,0,133,280.73Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M212.32,245.54l-64.47.53c-2.1,0-4.09,1-4.41,3.07l-7,47H103.18a1.94,1.94,0,0,0,0,3.87H209.26l7.25-49.6A4.24,4.24,0,0,0,212.32,245.54Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M212.32,245.54a3.57,3.57,0,0,1,1,.1,4.27,4.27,0,0,1,3.26,3.69,11.31,11.31,0,0,1-.24,2.65l-.93,6.55c-1.42,9.85-3.46,24.05-6,41.51l0,.17h-.17l-102.91.06h-2.77a2.65,2.65,0,0,1-1.46-.28,2.19,2.19,0,0,1,0-3.84,2.68,2.68,0,0,1,1.46-.27H136.4l-.25.22c2.53-16.83,4.9-32.53,7-46.62a3.66,3.66,0,0,1,1.2-2.45,4.81,4.81,0,0,1,2.46-1.09,20.87,20.87,0,0,1,2.6-.09l2.53,0,9.71-.06,17.25-.11,24.56-.13h8.84s-.19,0-.57,0l-1.7,0-6.57.09-24.56.27-17.25.18-9.71.09-2.53,0a23.4,23.4,0,0,0-2.53.09,4.35,4.35,0,0,0-2.25,1,3.18,3.18,0,0,0-1.05,2.2c-2.1,14.09-4.44,29.79-7,46.62l0,.22h-33a2.12,2.12,0,0,0-1.2.2,1.7,1.7,0,0,0-.77,2,1.74,1.74,0,0,0,.76.89,2.23,2.23,0,0,0,1.21.21h2.77l102.91.06-.2.17c2.59-17.45,4.69-31.64,6.15-41.49.37-2.45.7-4.64,1-6.53a11.93,11.93,0,0,0,.27-2.61,4.19,4.19,0,0,0-3.13-3.65A10,10,0,0,0,212.32,245.54Z",
    transform: "translate(-35.93 -29.44)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.42,
    cy: 242.74,
    r: 4.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139,299.57c.09,0,2.14-11.95,4.58-26.72s4.35-26.77,4.26-26.78-2.15,11.95-4.59,26.72S138.92,299.56,139,299.57Z",
    transform: "translate(-35.93 -29.44)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/Forgot_Password.bbdb5051593a617458628e2336db87dc.svg";
export { ForwardRef as ReactComponent };